import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { useEscortMonitor } from "./hooks/useEscortMonitor";
import { Routes, Route, Navigate, useLocation, BrowserRouter as Router } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import { useDispatch, useSelector } from "react-redux";
import soundFile from "./Raw/ring.wav";
import soundFileSiren from "./Raw/Siren.wav";
import ringWav from "./Raw/fbk.mp3";
import ring from "./Raw/ring.mp3";
import socketService from "../src/socket/newsocketService";
import apiClient from "./Utils/apiClient";
import { getDatabase, ref, onChildAdded, update, onChildChanged } from "firebase/database";
import { showStyledToast } from "components/toastAlert";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";
import "react-toastify/dist/ReactToastify.css";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { Link, useNavigate } from "react-router-dom";
import routes from "routes";
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import CustomNoti from "components/CustomNoti";
import VirtualTravelGuard from "components/VirtualTravelGuard";
import SecReqNoti from "components/SecReqNoti";
import SosModalCom from "components/SosModal";
import AlertModal from "components/AlerrtModal";
import HeartbeatThreatModal from "components/HeartbeatThreatModal";
import TriggerModal2 from "components/TriggerModal2";
import { getCurrentAdminState } from "Utils/Functions";
import DialogBox from "./DialogBox/DialogBox";
import TestComponent from "TestComponent";
import MainHeader from "layouts/MainHeader";
import ChatWindow from "Utils/ChatWindow";
import { addChatWindow } from "../src/Redux/Slice/dataSlice";
import StartChat from "components/StartChat";
import CargoEscortRequestCard from "layouts/CargoEscortRequestCard";
import VirtualTravelGuardModal from "components/VirtualTravelGuardModal";
import VehicleAlertModal from "DialogBox/VehicleAlertModal";
import SOSAlertModal from "DialogBox/SOSAlertModal";
import GeofenceModal from "DialogBox/GeofenceModal";
import CargoEscortModal from "../src/layouts/CargoEscort/CargoEscortModel";
import DriverEscortModal from "DialogBox/DriverEscortModal";
import NewDriverRegistrationModal from "DialogBox/NewDriverRegistrationModal";

const formatWithdrawalValue = (value) => String(value ?? "").trim() || "--";

const hasMeaningfulValue = (value) => {
  if (Array.isArray(value)) {
    return value.some((item) => hasMeaningfulValue(item));
  }

  return String(value ?? "").trim() !== "";
};

const extractVirtualTravelGuardData = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  const inner = raw.payload || raw.data || {};
  return { ...inner, ...raw };
};

const isValidVirtualTravelGuardPayload = (raw) => {
  if (!raw || typeof raw !== "object") {
    return false;
  }

  const combined = extractVirtualTravelGuardData(raw);

  const hasUserIdentity =
    hasMeaningfulValue(combined?.userId) ||
    hasMeaningfulValue(combined?.userObjectKey) ||
    hasMeaningfulValue(combined?._id) ||
    hasMeaningfulValue(combined?.userName) ||
    hasMeaningfulValue(combined?.userNam) ||
    hasMeaningfulValue(combined?.fullName) ||
    hasMeaningfulValue(combined?.Name) ||
    hasMeaningfulValue(combined?.userPhone) ||
    hasMeaningfulValue(combined?.PhoneNumber);

  const hasTripDetails = [
    combined?.ArrivalDate,
    combined?.arrivalDate,
    combined?.ArrivalTime,
    combined?.arrivalTime,
    combined?.TripDate,
    combined?.tripDate,
    combined?.TripTime,
    combined?.tripTime,
    combined?.destLocTxt,
    combined?.destLoc,
    combined?.destination,
    combined?.ArrivalStation,
    combined?.VehicleNumber,
    combined?.vehicleNumber,
    combined?.PartenerType,
    combined?.PartnerType,
    combined?.partnerType,
    combined?.PartnerRelation,
    combined?.PartnerName,
    combined?.partnerName,
    combined?.DepartStation,
    combined?.DepartureDate,
    combined?.DepartureTime,
  ].some((value) => hasMeaningfulValue(value));

  return Boolean(hasUserIdentity && hasTripDetails);
};

const WithdrawalDetailRow = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" color="text.secondary" display="block" fontWeight="bold">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
      {formatWithdrawalValue(value)}
    </Typography>
  </Grid>
);
export default function App() {
  useEscortMonitor();
  const location = useLocation();
  const isTestRoute = location?.pathname?.startsWith("/test");
  const dispatchh = useDispatch();
  const messageSound = useRef(new Audio(ringWav));
  const audioSiren = useRef(new Audio(soundFileSiren));
  const audioRing = useRef(new Audio(ring));
  const audio = new Audio(soundFile);
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  // ... (keep existing state declarations)

  const allData = useSelector((state) => state?.data?.allData);
  const allDataRef = useRef(allData);
  useEffect(() => {
    allDataRef.current = allData;
  }, [allData]);
  const accessKey = useSelector((state) => state.data.accessKey);
  const activeChats = useSelector((state) => state.data.activeChats);
  const [modals, setModals] = useState([]);
  const [open, setOpen] = useState(false);
  const [openVTG, setOpenVTG] = useState(false);
  const [travelData, setTravelData] = useState({});
  const [virtual, setVirtual] = useState([]);
  const [secReq, secSecReq] = useState([]);
  const [sosModal, setSosModal] = useState([]);
  const [policeAlert, setPoliceAlert] = useState([]);
  const [triggersZoneAlert, setTriggersZoneAlert] = useState([]);
  const [triggersBatteryAlert, setTriggersBatteryAlert] = useState([]);
  const [notificatioData, setnotificationData] = useState({});
  const [adminState, setAdminState] = useState(false);
  const [chatData, setChatData] = useState({});
  const [openChatModel, setOpenChatModel] = useState(false);
  const [openNoti, setOpenNoti] = useState(false);
  const [notiData, setNotiData] = useState(null);
  const [dispatchModal, setDispatchModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openCargoEscort, setOpenCargoEscort] = useState(false);
  const [openDriverEscort, setOpenDriverEscort] = useState(false);
  const [driverEscortData, setDriverEscortData] = useState(null);
  const [openNewDriverModal, setOpenNewDriverModal] = useState(false);
  const [newDriverModalData, setNewDriverModalData] = useState(null);
  const [yourFetchedRequestData, setYourFetchedRequestData] = useState(null);
  const [isChatVisible, setIsChatVisible] = useState(false);
  const [alertData, setAlertData] = useState(null);
  const [sosAlertModal, setSosAlertModal] = useState(false);
  const [geofenceModal, setGeofenceModal] = useState(false);
  const [geofenceData, setGeofenceData] = useState(null);
  const [SOSData, setSOSData] = useState(null);
  const [SOSModal, setSOSModal] = useState(false);
  const [withdrawalRequestData, setWithdrawalRequestData] = useState(null);
  const [withdrawalRequestOpen, setWithdrawalRequestOpen] = useState(false);

  const playAudioSafely = useCallback((audioEl, label = "audio") => {
    if (!audioEl) return;

    audioEl.loop = true;
    const playPromise = audioEl.play();

    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch((err) => {
        console.warn(`[App] ${label} playback blocked by browser:`, err);
      });
    }
  }, []);

  const closeWithdrawalRequestModal = useCallback(() => {
    audioSiren.current.currentTime = 0;
    audioSiren.current.pause();
    setWithdrawalRequestOpen(false);
    setWithdrawalRequestData(null);
  }, []);

  const handleSosSocketEvent = useCallback(async (data) => {
    const payload = data?.payload || data || {};
    const normalizedData = payload?.data || payload;
    const sosData = normalizedData?.alarmCode === "SOS" ? normalizedData : payload;

    try {
      const userId = sosData?.userId || sosData?.userObjectKey || sosData?.user_id || null;
      let fullUserData = {};

      if (userId) {
        const userResponse = await apiClient.get(`/users/${userId}`);
        const normalizedUserResponse = userResponse?.data ?? userResponse ?? {};
        fullUserData = normalizedUserResponse?.data ?? normalizedUserResponse ?? {};
      }

      const mergedSosData = {
        ...fullUserData,
        ...sosData,
        ...fullUserData?.user,
        userId: userId || fullUserData?._id || sosData?.userId || "",
        ownerName:
          sosData?.ownerName ||
          fullUserData?.userName ||
          fullUserData?.fullName ||
          fullUserData?.name ||
          sosData?.user_Name ||
          "Unknown",
        phone:
          sosData?.phone ||
          sosData?.user_Phone ||
          fullUserData?.userPhone ||
          fullUserData?.mobile ||
          fullUserData?.userPhoneP ||
          "N/A",
        location:
          sosData?.address ||
          sosData?.location ||
          fullUserData?.address ||
          fullUserData?.currentAddress ||
          "Location not available",
        currentLat: sosData?.Latitude ?? fullUserData?.Latitude ?? fullUserData?.currentLat ?? null,
        currentLong: sosData?.Longitude ?? fullUserData?.Longitude ?? fullUserData?.currentLong ?? null,
        lat: sosData?.Latitude ?? fullUserData?.Latitude ?? fullUserData?.currentLat ?? null,
        lng: sosData?.Longitude ?? fullUserData?.Longitude ?? fullUserData?.currentLong ?? null,
      };

      setSOSData(mergedSosData);
      setSOSModal(true);
      playAudioSafely(audioSiren.current, "siren");
    } catch (error) {
      console.error("[App] failed to fetch full user data for SOS modal:", error);
      setSOSData(sosData);
      setSOSModal(true);
      playAudioSafely(audioSiren.current, "siren");
    }
  }, [playAudioSafely]);

  const toggleChatWindow = () => {
    setIsChatVisible(!isChatVisible);
  };

  const openVirtualModal = useCallback(
    (notification) => {
      setVirtual([...virtual, notification]);
    },
    [virtual]
  );

  const openSecReqModal = useCallback(
    (notification) => {
      secSecReq([...secReq, notification]);
    },
    [secReq]
  );

  const closePoliceAlertModal = useCallback(
    (index) => {
      const updatedModals = [...policeAlert];
      updatedModals.splice(index, 1);
      setPoliceAlert(updatedModals);
      const audio = new Audio(soundFile);
      audio.loop = false;
      audio.pause();
      audio.currentTime = 0;
    },
    [policeAlert]
  );

  const closeTriggerZoneAlertModal = useCallback(
    (index) => {
      const updatedModals = [...triggersZoneAlert];
      updatedModals.splice(index, 1);
      setTriggersZoneAlert(updatedModals);
    },
    [triggersZoneAlert]
  );

  const closeTriggerBatteryAlertModal = useCallback(
    (index) => {
      const updatedModals = [...triggersBatteryAlert];
      updatedModals.splice(index, 1);
      setTriggersBatteryAlert(updatedModals);
    },
    [triggersBatteryAlert]
  );

  const closeSecModal = useCallback(
    (index) => {
      const updatedModals = [...secReq];
      updatedModals.splice(index, 1);
      secSecReq(updatedModals);
    },
    [secReq]
  );

  const closeVirtualModal = useCallback(
    (index) => {
      const updatedModals = [...virtual];
      updatedModals.splice(index, 1);
      setVirtual(updatedModals);
    },
    [virtual]
  );

  const closeSosModal = useCallback(
    (index) => {
      const updatedModals = [...sosModal];
      updatedModals.splice(index, 1);
      setSosModal(updatedModals);
    },
    [sosModal]
  );

  const openModal = useCallback(
    (notification) => {
      setModals([...modals, notification]);
    },
    [modals]
  );

  const closeModal = useCallback(
    (index) => {
      const updatedModals = [...modals];
      updatedModals.splice(index, 1);
      setModals(updatedModals);
    },
    [modals]
  );

  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    loggedIn,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(false);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(false);
    }
  };

  async function listenToNewUsers() {
    try {
      const db = getDatabase();
      const usersRef = ref(db, "users");

      onChildAdded(usersRef, (userSnapshot) => {
        const newUser = userSnapshot.val();
        const userId = userSnapshot.key;

        showStyledToast("info", "New user created", `${newUser.userName}`, () => { });
      });
    } catch (error) {
      // console.error("Error listening to new users:", error);
    }
  }

  async function listenToNewSOSAlerts() {
    try {
      const db = getDatabase();
      const usersRef = ref(db, "users");
      const currentAdminState = await getCurrentAdminState();
      const audio = new Audio(soundFile);
      const childUnsubs = [];

      const unsubUsers = onChildAdded(usersRef, (userSnapshot) => {
        const user = userSnapshot.val();
        const userId = userSnapshot.key;

        if (user && allDataRef.current && user.SOS) {
          const sosDataRef = ref(db, `users/${userId}/SOS`);
          const unsubChild = onChildAdded(sosDataRef, (dataSnapshot) => {
            const newData = dataSnapshot.val();

            if (!newData.isRead) {
              setSosModal((prev) => [
                ...prev,
                {
                  userId: userId,
                  sosData: newData,
                  userName: user.userName,
                  ...user,
                },
              ]);

              const playPromise = audio.play();
              if (playPromise && typeof playPromise.catch === "function") {
                playPromise.catch((err) => {
                  console.warn("[App] SOS alert audio blocked by browser:", err);
                });
              }
              const dataPath = `users/${userId}/SOS/${dataSnapshot.key}/isRead`;
              const updates = {};
              updates[dataPath] = true;
              update(ref(db), updates);
            }
          });
          childUnsubs.push(unsubChild);
        }
      });

      return () => {
        if (typeof unsubUsers === "function") unsubUsers();
        childUnsubs.forEach((u) => typeof u === "function" && u());
      };
    } catch (error) {
      return () => {};
    }
  }

  // function listenToNewSOSAlerts() {
  //   try {
  //     const db = getDatabase();
  //     const usersRef = ref(db, 'users');

  //     // Listen for changes in the 'users' reference
  //     onChildAdded(usersRef, (userSnapshot) => {
  //       const user = userSnapshot.val();
  //       const userId = userSnapshot.key;

  //       // Check if the user has 'SOS' data
  //       if (user.SOS) {
  //         const sosDataRef = ref(db, `users/${userId}/SOS`);

  //         // Listen for new child nodes added to 'SOS' for this user
  //         onChildAdded(sosDataRef, (dataSnapshot) => {
  //           const newData = dataSnapshot.val();
  //           // console.log("New SOS Alert Data:", newData);

  //           // Check if 'isRead' doesn't exist or is set to false
  //           if (!newData.isRead) {
  //             // Show a toast indicating that the data hasn't been read
  //             console.log(`New SOS Alert Data for User ${userId}:`, newData);
  //             const sosAlertId = dataSnapshot.key;
  //             showStyledToast(
  //               "info",
  //               "SOS Alert",
  //               `SOS Alert from ${user.userName}`,
  //               () => {
  //                 navigate(`/UserProfile/${userId}`);
  //               }
  //             );

  //             // Update the 'isRead' field to true using the 'set' method
  //             const dataPath = `users/${userId}/SOS/${dataSnapshot.key}/isRead`;
  //             const updates = {};
  //             updates[dataPath] = true;
  //             update(ref(db), updates);
  //           } else {
  //             // Data has already been read
  //             // console.log(`SOS Alert Data already read for User ${userId}:`, newData);
  //           }

  //           // You can take further action here with the new SOS alert data
  //         });
  //       }
  //     });
  //   } catch (error) {
  //     console.error('Error listening to new SOS alerts:', error);
  //   }
  // }

  useEffect(() => {
    // setMiniSidenav(dispatch, true )

    setOnMouseEnter(true);
    // showStyledToast(
    //   "info",
    //   "SOS Alert",
    //   `SOS Alert from test `,
    //   () => {
    //   }
    // );
  }, []);

  useEffect(() => {
    const storedUserRaw = localStorage.getItem("user");
    let storedUser = null;

    try {
      storedUser = storedUserRaw ? JSON.parse(storedUserRaw) : null;
    } catch (error) {
      storedUser = null;
    }

    const resolvedUserId =
      storedUser?._id || storedUser?.id || storedUser?.userId || storedUser?.key || localStorage.getItem("userId") || null;
    const resolvedState =
      storedUser?.state || storedUser?.userState || localStorage.getItem("state") || "";
    const resolvedIsSuperAdmin =
      storedUser?.superAdmin === true || storedUser?.superAdmin === "true";

    socketService.disconnect();
    if (resolvedUserId) {
      void socketService
        .initializeSocket(resolvedUserId, resolvedState, {
          isSuperAdmin: resolvedIsSuperAdmin,
          web: "true",
        })
        .catch((error) => {
          console.log("[App] socket initialization skipped or failed", error);
        });
    }

    const db = getDatabase();
    const usersRef = ref(db, "users");

    // Listen for changes in the 'users' node
    const unsubscribe = onChildAdded(usersRef, (userSnapshot) => {
      const user = userSnapshot.val();

      // Check if the user_seen property exists and is false
      if (user.user_seen === undefined || user.user_seen === false) {
        // Show a toast for the new user
        showStyledToast("info", "New User Added", `A new user has signed up`, () => {
          // Your callback function if needed
        });

        // Mark the user as seen in the database
        // update(ref(usersRef, `${userSnapshot.key}/user_seen`), true);

        const dataPath = `users/${userSnapshot.key}/user_seen`;
        const updates = {};
        updates[dataPath] = true;
        update(ref(db), updates);
      }
    });
    // console.error("Admin");
    socketService.on("shortdistanceescortadmin", async (data) => {
      console.log("[App] new short escort request received:", data);

      if (data?.action === "endescort") {
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent("stopEscortVoice", { detail: data }));
          if ("speechSynthesis" in window) {
            try {
              window.speechSynthesis.cancel();
            } catch (_) {}
          }
        }
        setOpen(false);
        return;
      }

      // Ignore updates, wellbeing checks, push notification broadcasts, and deletion events
      if (
        data?.action !== "create" &&
        (
          data?.action === "delete" ||
          data?.action === "resolved" ||
          data?.action === "update" ||
          data?.action === "wellbeing_check" ||
          Boolean(data?.wellbeingCheckSource) ||
          (Boolean(data?.wellbeingResponse) && data?.wellbeingResponse !== "Not Triggered") ||
          (Boolean(data?.userFBK) && data?.userFBK !== "No Feedback")
        )
      ) {
        return;
      }

      if (data?.cargoEscort) {
        setYourFetchedRequestData(data);
        setOpenCargoEscort(true);
        playAudioSafely(audioSiren.current, "siren");
        return;
      }

      const isDriverEscortRequest = Boolean(
        data?.isDriver ||
        data?.driverEscort ||
        data?.tripType === "driver" ||
        (data?.options === "Driving" && data?.driverId) ||
        data?.driverId
      );

      if (isDriverEscortRequest) {
        try {
          const userId = data?.userObjectKey || data?.userId || data?._id || null;
          const userResponse = userId ? await apiClient.get(`/users/${userId}`) : null;
          const userData = userResponse?.data || {};

          let tripData = {};
          let driverData = (data?.driver && typeof data.driver === "object") ? data.driver : (userData?.isDriver ? userData : {});
          if (data?.tripId) {
            try {
              const tripRes = await apiClient.get(`/escort-trip/${data.tripId}`);
              tripData = tripRes?.data?.trip || tripRes?.data || tripRes?.trip || tripRes || {};
              if (tripData?.driverId && typeof tripData.driverId === "object") {
                driverData = { ...driverData, ...tripData.driverId };
              }
            } catch (_) {}
          }

          setDriverEscortData({
            ...userData,
            ...data,
            user: userData,
            driver: driverData,
            trip: tripData,
          });
          setOpenDriverEscort(true);
          playAudioSafely(audioSiren.current, "siren");
          return;
        } catch (err) {
          console.error("Error routing driver escort request:", err);
          setDriverEscortData(data);
          setOpenDriverEscort(true);
          playAudioSafely(audioSiren.current, "siren");
          return;
        }
      }

      try {
        const userId = data?.userObjectKey || data?.userId || data?._id || null;
        const userResponse = userId ? await apiClient.get(`/users/${userId}`) : null;
        const userData = userResponse?.data || {};

        setnotificationData({
          ...userData,
          ...data,
          userObjectKey:
            userData?._id?.toString?.() || data?.userObjectKey || data?.userId || null,
          gsmMode: data?.gsmMode ?? userData?.gsmMode ?? true,
          userName: data?.userName || userData?.userName || "Unknown User",
          userPhone: data?.userPhone || userData?.userPhone || userData?.userPhoneP || "N/A",
          driverPhone: data?.driverPhone || userData?.driverPhone || "N/A",
          BatteryIndicator: data?.BatteryIndicator ?? userData?.BatteryIndicator ?? null,
          imgVehicle: data?.imgVehicle || userData?.imgVehicle || "",
          vehicleReg: data?.vehicleReg || userData?.vehicleReg || "",
          state: data?.state || userData?.state || "",
        });
        setOpen(true);
        playAudioSafely(audioSiren.current, "siren");
      } catch (error) {
        console.error("Failed to open short distance escort modal:", error);
        setnotificationData({
          ...data,
          userObjectKey: data?.userObjectKey || data?.userId || data?._id?.toString?.() || null,
          gsmMode: data?.gsmMode ?? true,
          userName: data?.userName || "Unknown User",
          userPhone: data?.userPhone || "N/A",
          driverPhone: data?.driverPhone || "N/A",
        });
        setOpen(true);
        playAudioSafely(audioSiren.current, "siren");
      }
    });

    socketService.on("notification", async (data) => {
      console.log(data);
      toast.success(data.text);
    });
    socketService.on("wellbeingcheck", async (data) => {
      // console.warn("wellbeingcheck");
      console.warn("[App] wellbeingcheck received:", data);
      if (!data || (!data.userName && !data.checkInType && !data.Interval)) {
        console.warn("[App] Ignoring wellbeingcheck event without user or check-in details:", data);
        return;
      }
      setSelectedUser({
        userName: data?.userName || "",
        checkInType: data?.checkInType || "",
        interval: data?.Interval || "",
        nextCheckIn: data?.Time || "",
        userId: data?.userId || "",
        userPhone: data?.mobile || "",
      });
      setDispatchModalOpen(true);
      playAudioSafely(audioSiren.current, "siren");
    });
socketService.on("cargoescortinit", async (data) => {
      console.log("NEW GLOBAL CARGO REQUEST =>", data);
      setYourFetchedRequestData({
        cargoEscort: true,
        data,
      });
      setOpenCargoEscort(true);

      playAudioSafely(audioSiren.current, "siren");
    });
    socketService.on("sos", async (data) => {
      console.log("[App] socket listener 'sos' triggered", data);
      handleSosSocketEvent(data);
    });
    socketService.on("SOS", async (data) => {
      console.log("[App] socket listener 'SOS' triggered", data);
      handleSosSocketEvent(data);
    });
    socketService.on("wanway", async (data) => {
      console.warn("[App] socket listener 'wanway' triggered", data);
      if (data?.alarmCode === "REMOVE" || data?.alarmCode === "REMOVECONTINUOUSLY") {
        setAlertData(data);
      } else if (data?.alarmCode === "FENCEOUT") {
        setGeofenceData((prev) => {
          if (prev?._id === data._id) return prev;
          return data;
        }); setGeofenceModal(true);
      } else if (data?.alarmCode === "SOS") {
        handleSosSocketEvent(data);
      }

      //
      // console.warn(data);
    });
    const handleDriverEscortRegistered = async (data) => {
      console.log("[App] new driver escort trip/request received:", data);
      showStyledToast(
        "info",
        "New Driver Escort Request",
        `A new escort request received. Driver: ${data?.driverName || data?.driver?.driverName || "Driver"}`,
        () => {}
      );
      try {
        const userId = data?.userObjectKey || data?.userId;
        const tripId = data?.tripId || data?._id;

        let userData = {};
        let driverData = (data?.driver && typeof data.driver === "object") ? data.driver : {};
        let tripData = {};

        if (userId) {
          try {
            const userResponse = await apiClient.get(`/users/${userId}`);
            userData = userResponse?.data || {};
          } catch (_) {}
        }

        if (tripId) {
          try {
            const tripResponse = await apiClient.get(`/escort-trip/${tripId}`);
            const resolvedTrip = tripResponse?.data?.trip || tripResponse?.data || tripResponse?.trip || tripResponse || {};
            tripData = resolvedTrip;
            if (resolvedTrip?.driverId && typeof resolvedTrip.driverId === "object") {
              driverData = { ...driverData, ...resolvedTrip.driverId };
            }
          } catch (_) {}
        }

        console.log("[App] driver escort full details fetched:", {
          user: userData,
          driver: driverData,
          trip: tripData,
          socketPayload: data,
        });

        setDriverEscortData({
          ...data,
          user: userData,
          driver: driverData,
          trip: tripData,
        });
        setOpenDriverEscort(true);
        playAudioSafely(audioSiren.current, "siren");
      } catch (err) {
        console.error("Error fetching driver escort details", err);
        setDriverEscortData(data);
        setOpenDriverEscort(true);
        playAudioSafely(audioSiren.current, "siren");
      }
    };

    socketService.on("driverEscortRegistered", handleDriverEscortRegistered);
    socketService.on("driverescort_request", handleDriverEscortRegistered);
    socketService.on("driverEscortRequest", handleDriverEscortRegistered);
    socketService.on("newDriverEscort", handleDriverEscortRegistered);

    const handleNewDriverRegistered = (data) => {
      console.log("[App] new driver registered socket event received:", data);
      const dName = data?.driverName || `${data?.firstName || ""} ${data?.surName || ""}`.trim() || "Driver";
      const reg = data?.regNo ? ` (${data.regNo})` : "";
      showStyledToast(
        "info",
        "New Driver Registered",
        `Driver ${dName}${reg} has registered. Click to verify.`,
        () => navigate("/drivers")
      );
      setNewDriverModalData(data);
      setOpenNewDriverModal(true);
      if (audioRing?.current) {
        audioRing.current.loop = false;
        audioRing.current.play()?.catch((e) => console.warn(e));
      }
    };

    socketService.on("new_driver_registered", handleNewDriverRegistered);
    socketService.on("driver_registered", handleNewDriverRegistered);
    socketService.removeAllListeners("escortchat");
    socketService.on("chat", (data) => {
      console.log("[App] chat received", data);
      const normalizedUserId = data?.userId || data?.userObjectKey || data?.chatUserId || data?.targetUserId;
      if (!normalizedUserId) return;
      if (data.isAdmin) { messageSound.current.loop = false; messageSound.current.play()?.catch(e => console.warn(e)); } else { audioRing.current.loop = false; audioRing.current.play()?.catch(e => console.warn(e)); }
      dispatchh(addChatWindow({ userId: normalizedUserId, username: data?.userName, message: data }));
    });
    socketService.on("escortchat", (data) => {
      console.log("[App] escortchat received", data);
      const normalizedUserId = data?.userId || data?.userObjectKey || data?.chatUserId || data?.targetUserId;
      if (!normalizedUserId) {
        return;
      }

      if (data.isAdmin) {
        messageSound.current.loop = false;
        messageSound.current.play()?.catch(e => console.warn(e));
      } else {
        audioRing.current.loop = false;
        audioRing.current.play()?.catch(e => console.warn(e));
      }

      dispatchh(
        addChatWindow({
          userId: normalizedUserId,
          username: data?.userName,
          message: data,
        }),
      );
    });
    return () => {
      // socket.off('notification');
      socketService.off("shortdistanceescortadmin");
      socketService.off("wellbeingcheck");
      socketService.off("cargoescortinit");
      socketService.off("driverEscortRegistered", handleDriverEscortRegistered);
      socketService.off("driverescort_request", handleDriverEscortRegistered);
      socketService.off("driverEscortRequest", handleDriverEscortRegistered);
      socketService.off("newDriverEscort", handleDriverEscortRegistered);
      socketService.off("new_driver_registered", handleNewDriverRegistered);
      socketService.off("driver_registered", handleNewDriverRegistered);
      socketService.disconnect();
      unsubscribe();
    };
  }, []);
  const handleClose = () => {
    audioSiren.current.currentTime = 0;
    audioSiren.current.pause();
    // console.log("paused");
    setOpen(false);
  };
  async function listenToNewPoliceAlerts() {
    try {
      const db = getDatabase();
      const usersRef = ref(db, "users");
      const currentAdminState = await getCurrentAdminState();
      const audio = new Audio(soundFile);
      const childUnsubs = [];

      const unsubUsers = onChildAdded(usersRef, (userSnapshot) => {
        const user = userSnapshot.val();
        const userId = userSnapshot.key;

        if (user && allDataRef.current && user.Police_Alerts) {
          const policeAlertsDataRef = ref(db, `users/${userId}/Police_Alerts`);

          const unsubChild = onChildAdded(policeAlertsDataRef, (dataSnapshot) => {
            const newData = dataSnapshot.val();

            if (!newData.isRead) {
              setPoliceAlert((prev) => [
                ...prev,
                {
                  ...user,
                  userId: userId,
                  ...newData,
                  userName: user.userName,
                },
              ]);

              audio.play()?.catch(e => console.warn(e));

              const dataPath = `users/${userId}/Police_Alerts/${dataSnapshot.key}/isRead`;
              const updates = {};
              updates[dataPath] = true;
              update(ref(db), updates);
            }
          });
          childUnsubs.push(unsubChild);
        }
      });

      return () => {
        if (typeof unsubUsers === "function") unsubUsers();
        childUnsubs.forEach((u) => typeof u === "function" && u());
      };
    } catch (error) {
      return () => {};
    }
  }

  useEffect(() => {
    socketService.on("wellbeingescort", (data) => {
      console.log("[App] socket event received: wellbeingescort", data);
      const isHomeCheck = Boolean(
        data &&
        !data.escortId &&
        !data.wellbeingResponse &&
        (data.locationType || data.PartnerName || data.Place || data.hotelName || (data.userName && data.Date && data.Time))
      );
      if (!isHomeCheck) {
        console.log("[App] Ignoring wellbeingescort event not belonging to Home Check:", data);
        return;
      }
      setNotiData({
        ...data,
        userName: data?.userName || "Unknown User",
        userPhone: data?.userPhone || "N/A",
        userEmail: data?.userEmail || "N/A",
        LiveLatitude: data?.currentLat,
        LiveLongitude: data?.currentLong,
        BatteryIndicator: data?.BatteryIndicator,
        Date: data?.Date && !isNaN(new Date(data.Date).getTime()) ? new Date(data.Date).toLocaleString() : (data?.Date || "N/A"),
        Time: data?.Time && !isNaN(new Date(data.Time).getTime()) ? new Date(data.Time).toLocaleTimeString() : (data?.Time || "N/A"),
        userId: data?.userId || "unknown-id",
      });
      setOpenNoti(true);
      playAudioSafely(audioSiren.current, "siren");
    });
  }, []);

  useEffect(() => {
    const handleWithdrawalRequest = (data = {}) => {
      console.log("[App] withdrawal request event received", data);

      if (data?.eventType !== "created") {
        return;
      }

      setWithdrawalRequestData(data);
      setWithdrawalRequestOpen(true);
      playAudioSafely(audioSiren.current, "siren");
      toast.info("New withdrawal request received");
    };

    socketService.on("whistleblowerwithdrawal", handleWithdrawalRequest);
    socketService.on("whistleblowerwithdrawalrequest", handleWithdrawalRequest);

    return () => {
      socketService.off("whistleblowerwithdrawal", handleWithdrawalRequest);
      socketService.off("whistleblowerwithdrawalrequest", handleWithdrawalRequest);
    };
  }, [playAudioSafely]);

  useEffect(() => {
    const handleVirtualTravelGuard = async (data) => {
      console.log("[App] socket event received: virtualtravelguard", data);

      const combined = extractVirtualTravelGuardData(data) || {};

      // Check if this is a stop, end, or completion event
      const action = String(combined?.action || "").toLowerCase();
      const tripStatus = String(combined?.Trip_Status || combined?.status || "").toLowerCase();
      const isStopOrEnd =
        action === "completed" ||
        action === "end" ||
        action === "stop" ||
        action === "delete" ||
        tripStatus === "completed" ||
        tripStatus === "stopped" ||
        tripStatus === "ended" ||
        combined?.tour === false ||
        combined?.active === false;

      if (isStopOrEnd) {
        console.log("[App] Virtual Travel Guard trip completed/stopped", data);
        setOpenVTG(false);
        if (audioSiren.current) {
          audioSiren.current.currentTime = 0;
          audioSiren.current.pause();
        }
        return;
      }

      // Ignore updates, wellbeing checks, push notification broadcasts, and feedback responses
      if (
        data?.action !== "create" &&
        (
          action === "delete" ||
          action === "resolved" ||
          action === "update" ||
          action === "feedback" ||
          action === "wellbeing_check" ||
          action === "wellbeing_response" ||
          action === "sharelocation" ||
          Boolean(combined?.wellbeingCheckSource) ||
          (Boolean(combined?.wellbeingResponse) && combined?.wellbeingResponse !== "Not Triggered") ||
          (Boolean(combined?.userFBK) && combined?.userFBK !== "No Feedback")
        )
      ) {
        console.log("[App] Ignoring virtualtravelguard event that is a wellbeing/feedback update:", combined);
        return;
      }

      if (!isValidVirtualTravelGuardPayload(data)) {
        console.log("[App] ignored incomplete virtualtravelguard payload", data);
        return;
      }

      const userId = combined?.userId || combined?.userObjectKey || combined?._id || "";
      let userName = combined?.userName || combined?.userNam || combined?.Name || "";
      let userPhone = combined?.userPhone || combined?.phone || combined?.PhoneNumber || "";
      let userImage = combined?.userImage || combined?.WellBeingTripPic || "";

      const partnerType =
        combined?.PartenerType ||
        combined?.PartnerType ||
        combined?.partnerType ||
        combined?.PartnerRelation ||
        "N/A";

      const partnerName =
        combined?.Name ||
        combined?.PartnerName ||
        combined?.partnerName ||
        "--";

      const partnerPhone =
        combined?.PhoneNumber ||
        combined?.PartnerMobileNo ||
        combined?.partnerPhone ||
        "N/A";

      const arrivalDate =
        combined?.ArrivalDate ||
        combined?.arrivalDate ||
        combined?.DepartureDate ||
        "N/A";

      const arrivalTime =
        combined?.ArrivalTime ||
        combined?.arrivalTime ||
        combined?.DepartureTime ||
        combined?.DepartTime ||
        "N/A";

      const tripDate =
        combined?.TripDate ||
        combined?.tripDate ||
        combined?.Date ||
        "N/A";

      const tripTime =
        combined?.TripTime ||
        combined?.tripTime ||
        combined?.Time ||
        "N/A";

      const currentLocTxt =
        combined?.currentLocTxt ||
        combined?.currentLoc ||
        combined?.currentLocation ||
        combined?.Place ||
        "---";

      const destLocTxt =
        combined?.destLocTxt ||
        combined?.destLoc ||
        combined?.destination ||
        combined?.ArrivalStation ||
        "---";

      const vehicleNumber =
        combined?.VehicleNumber ||
        combined?.vehicleNumber ||
        combined?.vehicleReg ||
        combined?.regNo ||
        "N/A";

      setTravelData({
        userId,
        userName: userName || "Unknown User",
        userImage,
        userPhone: userPhone || "N/A",
        ArrivalDate: arrivalDate,
        ArrivalTime: arrivalTime,
        PartenerType: partnerType,
        Name: partnerName,
        PhoneNumber: partnerPhone,
        sosSinalPic: combined?.sosSinalPic || "",
        TripDate: tripDate,
        TripTime: tripTime,
        Type: combined?.Type || combined?.type || (combined?.escortType === "short" ? "Virtual Escort (Short)" : "Virtual Travel Guard"),
        isRead: combined?.isRead || false,
        destLocTxt,
        currentLocTxt,
        Trip_Status: combined?.Trip_Status || combined?.status || "Active",
        lastName: combined?.lastName || "",
        VehicleNumber: vehicleNumber,
        DepartTime: combined?.DepartTime || arrivalTime,
        WellBeingTripPic: combined?.WellBeingTripPic || userImage,
        DepartureTime: combined?.DepartureTime || arrivalTime,
        DepartStation: combined?.DepartStation || "",
        ArrivalStation: combined?.ArrivalStation || "",
      });

      setOpenVTG(true);
      playAudioSafely(audioSiren.current, "siren");

      // Asynchronously fetch extra user details in background if missing without delaying modal presentation
      if ((!userName || userName === "Unknown" || !userPhone) && userId) {
        apiClient.get(`/users/${userId}`).then((userResponse) => {
          const userData = userResponse?.data || userResponse || {};
          const resolvedName = userData?.userName || userData?.fullName || userData?.name;
          const resolvedPhone = userData?.userPhone || userData?.phone || userData?.mobile;
          const resolvedImage = userData?.userImage;
          if (resolvedName || resolvedPhone || resolvedImage) {
            setTravelData((prev) => ({
              ...prev,
              ...(resolvedName ? { userName: resolvedName } : {}),
              ...(resolvedPhone ? { userPhone: resolvedPhone } : {}),
              ...(resolvedImage ? { userImage: resolvedImage } : {}),
            }));
          }
        }).catch((fetchErr) => {
          console.warn("[App] Could not fetch user data for VTG:", fetchErr);
        });
      }
    };

    socketService.on("virtualtravelguard", handleVirtualTravelGuard);
    socketService.on("virtualtravelguardrequest", handleVirtualTravelGuard);
    socketService.on("virtualescort_started", handleVirtualTravelGuard);

    return () => {
      socketService.off("virtualtravelguard", handleVirtualTravelGuard);
      socketService.off("virtualtravelguardrequest", handleVirtualTravelGuard);
      socketService.off("virtualescort_started", handleVirtualTravelGuard);
    };
  }, [playAudioSafely]);

  const CustomNotificationClose = () => {
    audioSiren.current.currentTime = 0;
    audioSiren.current.pause();
    setOpenNoti(false);
  };

  function listenToUserStatus() {
    try {
      const db = getDatabase();
      const usersRef = ref(db, "users");

      // Listen for changes in the 'users' reference
      onChildChanged(usersRef, (userSnapshot) => {
        const userId = userSnapshot.key;
        const user = userSnapshot.val();

        const status = ref(db, `users/${userId}`);

        onChildAdded(status, (dataSnapshot) => {
          const newData = dataSnapshot.val();
          alert(JSON.stringify(newData));
          // Check if the user has an IsMoving key and is explicitly set to false
          // if (newData.IsMoving !== undefined && newData.IsMoving === false) {
          //   // Show a toast indicating that the status has changed
          //   showStyledToast("info", "User Status", `${newData.userName} has stopped`);
          // } else if (newData.IsMoving) {
          //   // Show a toast indicating that the status has changed
          //   showStyledToast("info", "User Status", `${newData.userName} is moving`);
          // }
        });

        // console.log("User Data:", user); // Log user data to the console
      });
    } catch (error) {
      // console.error("Error listening to user status data:", error);
    }
  }

  async function listenToNewWhistleBlowData() {
    try {
      const db = getDatabase();
      const usersRef = ref(db, "users");
      const currentAdminState = await getCurrentAdminState();
      const audio = new Audio(soundFile);
      const childUnsubs = [];

      const unsubUsers = onChildAdded(usersRef, async (userSnapshot) => {
        const user = userSnapshot.val();
        const userId = userSnapshot.key;

        if (
          user.userState &&
          (allDataRef.current || user.userState.toLowerCase() === currentAdminState.toLowerCase()) &&
          user.Whistle_Blow
        ) {
          const whistleBlowDataRef = ref(db, `users/${userId}/Whistle_Blow`);

          const unsubChild = onChildAdded(whistleBlowDataRef, (dataSnapshot) => {
            const newData = dataSnapshot.val();

            if (!newData.isRead) {
              setPoliceAlert((prev) => [
                ...prev,
                {
                  ...user,
                  userId: userId,
                  userName: user.userName,
                  ...newData,
                },
              ]);

              audio.play()?.catch(e => console.warn(e));

              const dataPath = `users/${userId}/Whistle_Blow/${dataSnapshot.key}/isRead`;
              const updates = {};
              updates[dataPath] = true;
              update(ref(db), updates);
            }
          });
          childUnsubs.push(unsubChild);
        }
      });

      return () => {
        if (typeof unsubUsers === "function") unsubUsers();
        childUnsubs.forEach((u) => typeof u === "function" && u());
      };
    } catch (error) {
      return () => {};
    }
  }

  function listenToNewZonePssedData() {
    try {
      const db = getDatabase();
      const usersRef = ref(db, "users");
      const audio = new Audio(soundFile);
      const childUnsubs = [];

      const unsubUsers = onChildAdded(usersRef, async (userSnapshot) => {
        const user = userSnapshot.val();
        const userId = userSnapshot.key;

        if (user.userState && allDataRef.current && user.GeoFence) {
          const geoFenceDataRef = ref(db, `users/${userId}/GeoFence`);

          const unsubChild = onChildAdded(geoFenceDataRef, (dataSnapshot) => {
            const newData = dataSnapshot.val();

            if (!newData.isRead) {
              setTriggersZoneAlert((prev) => [
                ...prev,
                {
                  ...user,
                  userId: userId,
                  userName: user.userName,
                  ...newData,
                },
              ]);
              audio.play()?.catch(e => console.warn(e));
              const dataPath = `users/${userId}/GeoFence/${dataSnapshot.key}/isRead`;
              const updates = {};
              updates[dataPath] = true;
              update(ref(db), updates);
            }
          });
          childUnsubs.push(unsubChild);
        }
      });

      return () => {
        if (typeof unsubUsers === "function") unsubUsers();
        childUnsubs.forEach((u) => typeof u === "function" && u());
      };
    } catch (error) {
      return () => {};
    }
  }

  function listenToNewBatteryData() {
    try {
      const db = getDatabase();
      const usersRef = ref(db, "users");
      const audio = new Audio(soundFile);
      const childUnsubs = [];

      const unsubUsers = onChildAdded(usersRef, async (userSnapshot) => {
        const user = userSnapshot.val();
        const userId = userSnapshot.key;

        if (user.userState && allDataRef.current && user.BatteryLevels) {
          const batteryDataRef = ref(db, `users/${userId}/BatteryLevels`);

          const unsubChild = onChildAdded(batteryDataRef, (dataSnapshot) => {
            const newData = dataSnapshot.val();

            if (!newData.isRead) {
              setTriggersBatteryAlert((prev) => [
                ...prev,
                {
                  ...user,
                  userId: userId,
                  userName: user.userName,
                  ...newData,
                },
              ]);

              audio.play()?.catch(e => console.warn(e));
              const dataPath = `users/${userId}/BatteryLevels/${dataSnapshot.key}/isRead`;
              const updates = {};
              updates[dataPath] = true;
              update(ref(db), updates);
            }
          });
          childUnsubs.push(unsubChild);
        }
      });

      return () => {
        if (typeof unsubUsers === "function") unsubUsers();
        childUnsubs.forEach((u) => typeof u === "function" && u());
      };
    } catch (error) {
      return () => {};
    }
  }

  function listenToNewScurity_agent_requestsData() {
    try {
      const db = getDatabase();
      const usersRef = ref(db, "users");
      const audio = new Audio(soundFile);
      const childUnsubs = [];

      const unsubUsers = onChildAdded(usersRef, async (userSnapshot) => {
        const user = userSnapshot.val();
        const userId = userSnapshot.key;

        if (user.userState && allDataRef.current && user.Scurity_agent_requests) {
          const Scurity_agent_requestsRef = ref(db, `users/${userId}/Scurity_agent_requests`);

          const unsubChild = onChildAdded(Scurity_agent_requestsRef, (dataSnapshot) => {
            const newData = dataSnapshot.val();
            const mergedData = { ...user, ...newData, userId: userId };

            if (!("isRead" in newData) || newData.isRead === false) {
              const dataPath = `users/${userId}/Scurity_agent_requests/${dataSnapshot.key}/isRead`;
              const updates = {};
              updates[dataPath] = true;
              update(ref(db), updates);

              secSecReq((prev) => [...prev, mergedData]);
              audio.play()?.catch(e => console.warn(e));
            }
          });
          childUnsubs.push(unsubChild);
        }
      });

      return () => {
        if (typeof unsubUsers === "function") unsubUsers();
        childUnsubs.forEach((u) => typeof u === "function" && u());
      };
    } catch (error) {
      return () => {};
    }
  }

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    if (!loggedIn) {
      return () => null;
    }

    const cleanups = [];
    const runListeners = async () => {
      const u1 = await listenToNewWhistleBlowData();
      if (typeof u1 === "function") cleanups.push(u1);
      const u2 = await listenToNewSOSAlerts();
      if (typeof u2 === "function") cleanups.push(u2);
      const u3 = await listenToNewPoliceAlerts();
      if (typeof u3 === "function") cleanups.push(u3);
      const u4 = await listenToNewZonePssedData();
      if (typeof u4 === "function") cleanups.push(u4);
      const u5 = await listenToNewBatteryData();
      if (typeof u5 === "function") cleanups.push(u5);
      const u6 = await listenToNewScurity_agent_requestsData();
      if (typeof u6 === "function") cleanups.push(u6);
    };
    runListeners();

    return () => {
      cleanups.forEach((cleanup) => {
        try {
          cleanup();
        } catch (_) {}
      });
    };
  }, [loggedIn]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  // useEffect(() => {
  //   setTimeout(() => {
  //     const useradminAcess = localStorage.getItem("useradmin");

  //     if (useradminAcess) {
  //       setAdminState(useradminAcess === "true");
  //     } else {
  //       setAdminState(false);
  //     }
  //     console.log("getting useradmin access from App.js", useradminAcess);
  //   }, 100);

  //   // console.log("getting useradmin access", useradminAcess);
  // }, []);

  const withdrawalRequestDialog = (
    <Dialog
      open={withdrawalRequestOpen}
      onClose={closeWithdrawalRequestModal}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        New Withdrawal Request
        <Typography variant="caption" display="block" color="text.secondary">
          {withdrawalRequestData?.reference || withdrawalRequestData?.requestId || "--"}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              alignItems: "center",
            }}
          >
            <Chip
              label={withdrawalRequestData?.withdrawalMethod || "UNKNOWN"}
              size="small"
              sx={{ fontWeight: 700 }}
            />
            <Chip
              label={withdrawalRequestData?.status || "pending"}
              size="small"
              sx={{ fontWeight: 700 }}
            />
          </Box>

          <Grid container spacing={2}>
            <WithdrawalDetailRow label="Full Name" value={withdrawalRequestData?.fullName || withdrawalRequestData?.userName} />
            <WithdrawalDetailRow label="Phone Number" value={withdrawalRequestData?.phoneNumber || withdrawalRequestData?.userPhone} />
            <WithdrawalDetailRow label="Email Address" value={withdrawalRequestData?.emailAddress || withdrawalRequestData?.userEmail} />
            <WithdrawalDetailRow label="State" value={withdrawalRequestData?.state} />
            <WithdrawalDetailRow label="Report Reference" value={withdrawalRequestData?.reportReference} />
            <WithdrawalDetailRow label="Request ID" value={withdrawalRequestData?.requestId || withdrawalRequestData?.id} />
            <WithdrawalDetailRow label="Identification Type" value={withdrawalRequestData?.identificationType} />
            <WithdrawalDetailRow label="Identification Number" value={withdrawalRequestData?.identificationNumber} />
            <WithdrawalDetailRow label="Bank Name" value={withdrawalRequestData?.bankName} />
            <WithdrawalDetailRow label="Account Name" value={withdrawalRequestData?.accountName} />
            <WithdrawalDetailRow label="Account Number" value={withdrawalRequestData?.accountNumber} />
            <WithdrawalDetailRow label="Reward Amount" value={withdrawalRequestData?.rewardAmount} />
            <WithdrawalDetailRow label="Locked Reward" value={withdrawalRequestData?.lockedReward} />
            <WithdrawalDetailRow label="Admin Note" value={withdrawalRequestData?.adminNote} />
          </Grid>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            closeWithdrawalRequestModal();
            navigate("/WhistleBlowerWithdrawals/");
          }}
          variant="contained"
          color="info"
        >
          Open Withdrawals
        </Button>
        <Button onClick={closeWithdrawalRequestModal} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );

  const driverEscortDialog = (
    <DriverEscortModal
      open={openDriverEscort}
      onClose={() => {
        setOpenDriverEscort(false);
        if (audioSiren?.current) {
          audioSiren.current.currentTime = 0;
          audioSiren.current.pause();
        }
      }}
      data={driverEscortData}
    />
  );

  const configsButton = (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="small" color="inherit">
        settings
      </Icon>
    </MDBox>
  );

  return (
    <>
      {open && <DialogBox userInfo={notificatioData || {}} open={open} onClose={handleClose} />}
      {withdrawalRequestDialog}
      {driverEscortDialog}
      <NewDriverRegistrationModal
        open={openNewDriverModal}
        onClose={() => setOpenNewDriverModal(false)}
        driverData={newDriverModalData}
      />

      {direction === "rtl" ? (
        <CacheProvider value={rtlCache}>
          <ToastContainer />
          <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
            <CssBaseline />
            <ToastContainer />

            {!isTestRoute && layout === "dashboard" && (
              <>
                {/* {controller?.accessKey && <MainHeader />} */}
                {/* {accessKey && <MainHeader />} */}
                <MainHeader />

                {Object.keys(activeChats).map((userId, index) => {
                  const { username } = activeChats[userId];
                  return (
                    <ChatWindow key={userId} userId={userId} username={username} index={index} />
                  );
                })}
                <Sidenav
                  color={sidenavColor}
                  brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
                  brandName="Karzame"
                  routes={routes}
                  onMouseEnter={handleOnMouseEnter}
                  onMouseLeave={handleOnMouseLeave}
                />
                <Configurator />
                {configsButton}
              </>
            )}
            {layout === "vr" && <Configurator />}
            <Routes>
              {getRoutes(routes)}
              {!loggedIn ? (
                <>
                  <Route path="/test/:userObjectKey" element={<TestComponent />} />
                  <Route path="*" element={<Navigate to="/authentication/sign-in" />} />
                </>
              ) : (
                <Route path="*" element={<Navigate to="/dashbord" />} />
              )}
            </Routes>
          </ThemeProvider>
        </CacheProvider>
      ) : (
        <ThemeProvider theme={darkMode ? themeDark : theme}>
          <CssBaseline />

          {!isTestRoute && layout === "dashboard" && (
            <>
              {/* {controller.accessKey && <MainHeader />} */}
              {/* {accessKey && <MainHeader />} */}
              <MainHeader />
              {Object.keys(activeChats).map((userId, index) => {
                const { username } = activeChats[userId];
                return (
                  <ChatWindow key={userId} userId={userId} username={username} index={index} />
                );
              })}
              <Sidenav
                color={sidenavColor}
                brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
                brandName="Karzame"
                routes={routes}
                onMouseEnter={handleOnMouseEnter}
                onMouseLeave={handleOnMouseLeave}
              />
              <Configurator />
              {configsButton}
            </>
          )}
          {layout === "vr" && <Configurator />}
          <Routes>
            {getRoutes(routes)}
            {!loggedIn ? (
              <>
                <Route path="/test/:userObjectKey" element={<TestComponent />} />
                <Route path="*" element={<Navigate to="/authentication/sign-in" />} />
              </>
            ) : (
              <Route path="*" element={<Navigate to="/" />} />
            )}

            {/* <Route path="*" element={<Navigate to="/authentication/sign-in" />} /> */}
          </Routes>
          <ToastContainer />

          {/* {modals.map((notification, index) => (
            <div className="position-relative">
              <CustomNoti
                index={index}
                key={index}
                isOpen={true}
                onClose={() => closeModal(index)}
                notification={notification}
                type={"Virtual Home Check "}
              />
            </div>
          ))} */}
          {openNoti && (
            <CustomNoti
              isOpen={openNoti}
              onClose={CustomNotificationClose}
              notification={notiData}
              index={0}
              type="Wellbeing Escort"
            />
          )}

          {alertData && <VehicleAlertModal data={alertData} onClose={() => setAlertData(null)} />}
          {SOSModal && (
            <SOSAlertModal open={SOSModal} data={SOSData} handleClose={() => setSOSModal(false)} />
          )}

          {geofenceModal && (
            <GeofenceModal
              open={geofenceModal}
              data={geofenceData}
              onClose={() => setGeofenceModal(false)}
            />
          )}

          {openVTG && (
            <VirtualTravelGuardModal
              isOpen={openVTG}
              onClose={() => {
                setOpenVTG(false);
                if (audioSiren.current) {
                  audioSiren.current.currentTime = 0;
                  audioSiren.current.pause();
                }
              }}
              data={travelData}
              index={0}
            />
          )}

          {openCargoEscort && (
            <CargoEscortRequestCard
              open={openCargoEscort}
              onClose={() => {
                setOpenCargoEscort(false);
              }}
              data={yourFetchedRequestData}
            />
          )}

          {dispatchModal && (
            <StartChat
              open={dispatchModal}
              onClose={() => setDispatchModalOpen(false)}
              userData={selectedUser}
            />
          )}

          {virtual.map((notification, index) => (
            <div className="position-relative">
              <VirtualTravelGuard
                index={index}
                key={index}
                isOpen={true}
                onClose={() => closeVirtualModal(index)}
                notification={notification}
                type={"Virtual travel Guard "}
              />
            </div>
          ))}

          {secReq.map((notification, index) => (
            <div className="position-relative">
              <SecReqNoti
                index={index}
                key={index}
                isOpen={true}
                onClose={() => closeSecModal(index)}
                notification={notification}
                type={"Virtual travel Guard "}
              />
            </div>
          ))}

          {sosModal.map((notification, index) => (
            <div className="position-relative">
              <SosModalCom
                index={index}
                key={index}
                isOpen={true}
                onClose={() => closeSosModal(index)}
                notification={notification}
                type={"Modal"}
              />
            </div>
          ))}

          {/* Real-Time Dead Man's Switch 5-10m Heartbeat Threat Alert Popup */}
          <HeartbeatThreatModal />

          {policeAlert.map((notification, index) => (
            // console.log("item at mao", notification),
            <div className="position-relative">
              <AlertModal
                index={index}
                key={index}
                isOpen={true}
                onClose={() => closePoliceAlertModal(index)}
                notification={notification}
                type={"Modal"}
              />
            </div>
          ))}

          {triggersZoneAlert.map((notification, index) => (
            // console.log("item at triggersZoneAlert", notification),
            <div className="position-relative">
              <TriggerModal2
                icon={true}
                onCloseTrigger={() => closeTriggerZoneAlertModal(index)}
                triggerModal={true}
                triggerModalData={notification}
                triggerTitle={"Virtual Guard Alert Zone Passed"}
              />
            </div>
          ))}
          {openCargoEscort && (
            <CargoEscortModal
             open={openCargoEscort}
              onClose={() => {
                audioSiren.current.pause();
                audioSiren.current.currentTime = 0;
                setOpenCargoEscort(false);
              }}
              data={yourFetchedRequestData}
            />
          )}
          {/* <CargoEscortRequestCard
            open={openCard}
            onOpen={() => setOpenCard(true)}
            onClose={() => setOpenCard(false)}
          /> */}

          {/* <CargoEscortRequestCard
            open={openCard}
            onClose={() => {
              setOpenCard(false);
            }}
          /> */}

          {triggersBatteryAlert.map((notification, index) => (
            // console.log("item at triggersBatteryAlert", notification),
            <div className="position-relative">
              <TriggerModal2
                icon={false}
                onCloseTrigger={() => closeTriggerBatteryAlertModal(index)}
                triggerModal={true}
                triggerModalData={notification}
                triggerTitle={"Virtual Guard Alert Low Battery"}
              />
            </div>
          ))}
        </ThemeProvider>
      )}
    </>
  );
}
